/* tslint:disable:no-shadowed-variable */

import { environment as ci } from '../../../environments/environment.ci';
import { environment as ci2 } from '../../../environments/environment.ci2';
import { environment as dev } from '../../../environments/environment.dev';
import { environment as prod } from '../../../environments/environment.prod';
import { environment as qa } from '../../../environments/environment.qa';
import { environment as sec } from '../../../environments/environment.sec';
import { environment as uat } from '../../../environments/environment.uat';
import { environment as local } from '../../../environments/environment.local';
import { Inject, Injectable, InjectionToken } from '@angular/core';

declare var window: any;

export const environments = {
  default: local,
  ci,
  ci2,
  dev,
  prod,
  qa,
  sec,
  uat
};

export interface EnvironmentConfigurationSettings {
  [setting: string]: any;
}

export interface EnvironmentConfigurations {
  default: EnvironmentConfigurationSettings;
  [environment: string]: EnvironmentConfigurationSettings;
}

export const Environments = new InjectionToken<EnvironmentConfigurations>('Environments');

@Injectable()
export class EnvironmentConfiguration implements EnvironmentConfigurationSettings {
  [setting: string]: any;
  constructor(@Inject(Environments) environments: EnvironmentConfigurations) {
    const hostname = (window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : null;
    let environmentType = environments.default;

    const environmentNames: string[] = Object.keys(environments).filter(envName => envName !== 'default');

    const selectedEnvName = environmentNames.find(envName => {
      if (environments[envName] && environments[envName].hostname) {
        return environments[envName].hostname.toLowerCase() === hostname;
      } else {
        return false;
      }
    });

    if (selectedEnvName && environments[selectedEnvName]) {
      environmentType = environments[selectedEnvName];
    }

    // Override default behavior by setting window.environment in index.html
    if (window['environment'] && environments[window['environment']]) {
      environmentType = environments[window['environment']];
    }

    Object.assign(this, environmentType);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/environment/services/environment.configuration.ts